{
  "nav": {
    "application": "Приложение",
    "organization": "Организация",
    "dashboard": "Панель",
    "requests": "Запросы",
    "users": "Пользователи",
    "models": "Модели",
    "settings": "Настройки"
  },
  "userMenu": {
    "settings": "Настройки",
    "signOut": "Выйти"
  },
  "theme": {
    "change": "Сменить тему",
    "light": "Светлая",
    "dark": "Тёмная",
    "system": "Системная"
  },
  "research": {
    "title": "Исследовательская демонстрация — не медицинское изделие",
    "body": "Все результаты на этой странице предназначены только для исследований, используют некалиброванные сигналы моделей и требуют проверки квалифицированным рентгенологом. Ничто здесь не является диагнозом.",
    "demoBody": "Это детерминированные имитационные результаты на основе меток публичного тестового набора; медицинские модели и API моделей не вызывались. Это не диагностический результат и он требует квалифицированной проверки человеком.",
    "liveDemoBody": "Результаты реальных моделей на открытых обезличенных снимках. Оценки служат для ранжирования и не являются вероятностями заболеваний. Требуется проверка специалистом."
  },
  "status": {
    "uploaded": "Загружено",
    "validating": "Проверка",
    "rejected": "Отклонено",
    "accepted": "Принято",
    "readers_queued": "Модели в очереди",
    "readers_running": "Модели работают",
    "reconciling": "Согласование",
    "abstained": "Воздержание",
    "evidence_ready": "Результаты готовы",
    "reviewed": "Отрецензировано"
  },
  "states": {
    "present": "Обнаружено",
    "presentWithSeverity": "Обнаружено ({{severity}})",
    "uncertain": "Неопределённо",
    "absent": "Не обнаружено",
    "not_assessed": "Не оценивалось",
    "yes": "Да",
    "no": "Нет"
  },
  "severity": {
    "mild": "лёгкая степень",
    "moderate": "умеренная степень",
    "severe": "тяжёлая степень"
  },
  "auth": {
    "welcome": "Добро пожаловать",
    "subtitle": "Войдите в аккаунт или создайте новый.",
    "demoSubtitle": "Войдите с общим демо-аккаунтом. Регистрация отключена.",
    "signIn": "Войти",
    "signUp": "Регистрация",
    "email": "Эл. почта",
    "password": "Пароль",
    "signingIn": "Вход…",
    "inviteCode": "Код приглашения",
    "inviteHint": "Регистрация только по приглашениям. Запросите код у администратора.",
    "passwordHint": "Не менее 12 символов.",
    "confirmPassword": "Подтвердите пароль",
    "createAccount": "Создать аккаунт",
    "creatingAccount": "Создание аккаунта…"
  },
  "dashboard": {
    "activeSessions": "Активные сессии",
    "memberSince": "Дата регистрации",
    "accountTitle": "Ваш аккаунт",
    "accountSubtitle": "Это видите только вы — у каждого пользователя свой контент.",
    "email": "Эл. почта",
    "role": "Роль",
    "emailVerified": "Почта подтверждена",
    "verified": "Подтверждена",
    "notVerified": "Не подтверждена"
  },
  "settings": {
    "title": "Настройки",
    "language": {
      "title": "Язык",
      "subtitle": "Язык интерфейса для этого аккаунта.",
      "en": "English",
      "ru": "Русский"
    },
    "emailTitle": "Адрес эл. почты",
    "emailSubtitle": "После смены почты потребуется повторное подтверждение.",
    "currentPassword": "Текущий пароль",
    "updateEmail": "Обновить почту",
    "passwordTitle": "Пароль",
    "passwordSubtitle": "Смена пароля завершит остальные сессии.",
    "newPassword": "Новый пароль",
    "confirmNewPassword": "Подтвердите новый пароль",
    "updatePassword": "Обновить пароль",
    "sessionsTitle": "Ваши сессии",
    "sessionsSubtitle": "Устройства, вошедшие в ваш аккаунт.",
    "device": "Устройство",
    "ipAddress": "IP-адрес",
    "signedIn": "Вход выполнен",
    "actions": "Действия",
    "thisDevice": "Это устройство",
    "revoke": "Отозвать",
    "unknownDevice": "Неизвестное устройство"
  },
  "common": {
    "roleAdmin": "Администратор",
    "roleMember": "Участник",
    "delete": "Удалить",
    "actions": "Действия",
    "yes": "Да",
    "no": "Нет",
    "never": "Никогда",
    "search": "Поиск"
  },
  "requests": {
    "title": "Запросы на анализ",
    "subtitle": "Запросы на анализ рентгенограмм грудной клетки через конвейер доказательств.",
    "new": "Новый запрос",
    "searchPlaceholder": "Поиск по названию или ID запроса",
    "allStatuses": "Все статусы",
    "allPatients": "Все пациенты",
    "colRequest": "Запрос",
    "colName": "Название",
    "colPatient": "Пациент",
    "colStatus": "Статус",
    "colSource": "Источник",
    "colCreatedBy": "Автор",
    "colCreated": "Создан",
    "empty": "Запросов пока нет. Создайте первый.",
    "upload": "Загрузка",
    "colResults": "Запуски моделей",
    "recordedCount": "{{count}} записано",
    "open": "Открыть результаты"
  },
  "newRequest": {
    "title": "Новый запрос на анализ",
    "subtitle": "Одна деидентифицированная фронтальная рентгенограмма взрослого на запрос. Неподдерживаемые данные отклоняются до вызова моделей.",
    "name": "Название запроса",
    "namePlaceholder": "напр. Отделение B, контроль",
    "patient": "Пациент (необязательная привязка)",
    "noPatient": "Без пациента",
    "existingPlaceholder": "Существующий",
    "newCodePlaceholder": "или новый код, напр. case-042",
    "patientHint": "Только исследовательский код связи — никогда не настоящий идентификатор пациента.",
    "imageSource": "Источник изображения",
    "datasetTab": "Dataset",
    "uploadTab": "Загрузить снимок",
    "datasetHint": "Выберите один образец",
    "datasetHint2": "— отслеживаемые публичные исследовательские данные. Контрольные суммы проверяются перед использованием; критерии допуска берутся из манифеста.",
    "demoDatasetHint": "Выберите публичный образец, чтобы сразу открыть детерминированные симулированные результаты моделей. API моделей не вызывается.",
    "liveDemoDatasetHint": "Выберите открытый пример. Модели загружаются по запросу; первый результат может занять несколько минут.",
    "demoOpening": "Открываем результаты…",
    "colSample": "Образец",
    "colView": "Проекция",
    "colAge": "Возраст",
    "colSex": "Пол",
    "colLabel": "Референсная метка",
    "fileLabel": "Рентгенограмма (DICOM, PNG или JPEG)",
    "fileHint": "Содержимое проверяется на сервере — расширениям и MIME-типам не доверяем.",
    "view": "Проекция",
    "policyTitle": "Обязательные подтверждения",
    "policyHint": "Ложные или отсутствующие подтверждения останавливают запрос до вызова моделей.",
    "create": "Создать запрос",
    "creating": "Создание…",
    "selectSampleHint": "Выберите образец, чтобы продолжить.",
    "attachFileHint": "Прикрепите файл, чтобы продолжить.",
    "setLabel": "Набор данных",
    "sets": {
      "testing-set-1": "testing-set-1 — CheXpert (широкий спектр признаков)",
      "testing-set-3": "testing-set-3 — Shenzhen (туберкулёз лёгких)"
    },
    "primaryLabels": {
      "positive": "ТБ-совместимые проявления (эталонная метка)",
      "negative": "Норма (эталонная метка набора)"
    },
    "viewNames": {
      "PA": "PA — задне-передняя",
      "AP": "AP — передне-задняя"
    },
    "viewHints": {
      "PA": "Стандартный снимок стоя: пациент обращён лицом к детектору, луч идёт со спины вперёд. Предпочтительна, если пациент может стоять — сердце ближе к детектору, его тень не увеличена.",
      "AP": "Луч идёт спереди назад, обычно снимок лёжа или переносным аппаратом, когда пациент не может стоять. Сердце дальше от детектора и выглядит крупнее — оценивать размеры сердца с осторожностью."
    },
    "demoUploadTab": "Загрузить демо-снимок",
    "demoUploadTitle": "Демо-набор на рабочем столе",
    "demoUploadHint": "Выберите один снимок из MedAI Demo Kit / 01_upload. Используйте исходный файл: скриншоты и изменённые копии не принимаются.",
    "demoUploadFile": "Открытый демо-снимок (PNG или JPEG)",
    "demoUploadMatched": "Возраст и проекция определяются по разрешённому открытому источнику. Исследовательский результат требует проверки специалистом."
  },
  "policy": {
    "adult_verified": "Исследование взрослого пациента (18+)",
    "single_frontal_image": "Ровно один фронтальный снимок PA/AP",
    "cxr_modality": "Это рентгенограмма грудной клетки (CXR/CR/DX)",
    "no_burned_in_identifiers": "Нет впечатанных идентификаторов пациента"
  },
  "policyShort": {
    "adult_verified": "Взрослый подтверждён",
    "single_frontal_image": "Один фронтальный снимок PA/AP",
    "cxr_modality": "Модальность CXR",
    "no_burned_in_identifiers": "Нет впечатанных идентификаторов"
  },
  "show": {
    "createdBy": "автор",
    "patientLabel": "пациент",
    "tabIntake": "Приём и проверка",
    "tabAnalysis": "Анализ",
    "tabFeedback": "Валидация врача",
    "retry": "Повторить конвейер",
    "noPatient": "без пациента",
    "selectPatient": "Выбрать пациента",
    "orNewCode": "или новый код",
    "linkPatient": "Привязать пациента",
    "intakeTitle": "1 · Приём и проверка",
    "intakeSubtitle": "Детерминированный контроль — содержимое проверяется, подтверждения обязательны до вызова моделей.",
    "sourceDataset": "Источник: набор {{sample}}",
    "sourceUpload": "Источник: загрузка",
    "viewBadge": "Проекция: {{view}}",
    "rejectedTitle": "Отклонено до вызова моделей",
    "deidentTitle": "2 · Деидентификация",
    "deidentSubtitle": "Ниже показаны все метаданные исходного файла, затем они удаляются: модели получают только производное изображение без метаданных.",
    "colField": "Поле источника",
    "colValue": "Значение",
    "noMetadata": "Метаданные ещё не извлечены.",
    "originalSha": "SHA-256 оригинала:",
    "derivativeSha": "SHA-256 производного:",
    "derivativeCaption": "Производный PNG без метаданных (то, что видят модели).",
    "analysisTitle": "3 · Анализ",
    "analysisSubtitle": "Основные модели работают независимо; результаты согласуются детерминированным кодом приложения. Значения MedSigLIP — некалиброванные ранжирующие оценки, а не вероятности заболеваний.",
    "running": "Модели формируют результаты ({{status}})… колонки заполняются по мере завершения.",
    "colFinding": "Признак",
    "colVerdict": "Исследовательское согласование",
    "descUncalibrated": "балл ранжирования · без калибровки",
    "descReaderState": "заключение модели",
    "descChallengerScore": "претендент · оценка",
    "descChallengerTb": "претендент · только ТБ",
    "descChallengerState": "претендент · заключение",
    "verdictAccepted": "Для проверки",
    "verdictDisagreement": "Расхождение",
    "footnote": "«Не оценено» означает отсутствие результата модели для этой находки; тире в столбце согласования — правило не выбрало находку. Баллы разных семейств моделей не усредняются. Политика согласования: {{version}}. Демонстрационное правило не прошло клиническую валидацию.",
    "abstainedTitle": "Воздержание — автоматические доказательства не сформированы",
    "provenanceToggle": "Запуски моделей и происхождение ({{count}})",
    "provStatus": "статус",
    "provAttempts": "попытки",
    "provRevision": "ревизия",
    "provAdapter": "адаптер",
    "provPrompts": "промпты",
    "provPreprocessing": "препроцессинг",
    "provTiming": "время",
    "provWarnings": "предупреждения",
    "feedbackTitle": "4 · Отзыв рецензента",
    "feedbackSubtitle": "Проверка человеком — финальный обязательный шаг: квалифицированный рецензент подтвердит или исправит согласованные доказательства.",
    "feedbackPlaceholder": "Ещё не реализовано — следующий этап.",
    "print": "Печать отчёта",
    "retryModel": "повторить",
    "embeddingSummary": "эмбеддинг {{dimension}}-мерный · векторов: {{vectors}}",
    "embeddingNone": "эмбеддинг не получен",
    "verdictChallengerSignal": "сигнал претендента",
    "statusNoOutput": "отработала, но не сообщила ни одного признака",
    "statusAbstained": "воздержалась — модель отказалась отвечать"
  },
  "summary": {
    "title": "Сводка доказательств",
    "partialBadge": "частичные данные",
    "stale": "Данные или статус безопасности изменились. Перед использованием обновите сводку.",
    "regenerate": "Сформировать заново с новыми данными",
    "generateNow": "Сформировать резюме сейчас",
    "partialHint": "Некоторые модели ещё работают — резюме будет частичным.",
    "waiting": "Ожидание первых результатов моделей…",
    "generatedAuto": "сформировано автоматически",
    "generatedBy": "сформировано: {{email}}",
    "attribution": "Составлено по детерминированным правилам из структурированных данных; это не сгенерированное заключение рентгенолога.",
    "previousOne": "1 предыдущая версия",
    "previousMany": "Предыдущих версий: {{count}}",
    "partialLabel": "частичное",
    "automatic": "автоматически",
    "lead": "Исследование выявляет признаки, совместимые со следующими:",
    "leadNone": "Нет принятых положительных находок; это не исключает заболевание.",
    "uncertainTitle": "Неопределённо",
    "disagreementTitle": "Расхождение моделей",
    "disclaimer": "Только для исследовательских целей — требуется проверка квалифицированным рентгенологом.",
    "scoreLabel": "MedSigLIP {{score}}",
    "history": "История версий ({{count}})",
    "current": "текущая",
    "findingsSentence": "Исследование выявляет признаки, совместимые с: {{findings}}.",
    "uncertainSentence": "Неопределённо: {{findings}}.",
    "disagreementSentence": "Расхождение моделей: {{findings}}.",
    "unavailable": "Сводка недоступна. Проверьте статус запроса и ответы отдельных моделей."
  },
  "adminPanel": {
    "invitesTitle": "Коды приглашений",
    "invitesSubtitle": "Регистрация только по приглашениям. Создавайте и делитесь кодами здесь.",
    "maxUses": "Макс. использований",
    "expiresDays": "Истекает через (дней)",
    "expiresNever": "никогда",
    "generate": "Создать код",
    "colCode": "Код",
    "colStatus": "Статус",
    "colUses": "Использований",
    "colExpires": "Истекает",
    "colUsedBy": "Использован",
    "statusActive": "Активен",
    "statusRevoked": "Отозван",
    "statusExhausted": "Исчерпан",
    "statusExpired": "Истёк",
    "revoke": "Отозвать",
    "activate": "Активировать",
    "copy": "Скопировать {{code}}",
    "emptyInvites": "Кодов пока нет. Создайте первый выше.",
    "usersTitle": "Пользователи",
    "usersSubtitle": "Управление ролями и удаление аккаунтов.",
    "colEmail": "Эл. почта",
    "colRole": "Роль",
    "colInvite": "Приглашение",
    "colVerified": "Подтверждён",
    "colJoined": "Регистрация",
    "makeAdmin": "Сделать администратором",
    "makeMember": "Сделать участником",
    "you": "Вы",
    "deleteConfirm": "Удалить {{email}}? Это действие необратимо."
  },
  "modelsPage": {
    "keyMissing": "RUNPOD_API_KEY не настроен — живой статус эндпоинтов недоступен. Проверки статуса только читают данные и никогда не запускают оплачиваемые воркеры.",
    "title": "Парк моделей",
    "subtitle": "Из зафиксированного реестра моделей. Режим адаптеров:",
    "liveCalls": "живые вызовы инференса:",
    "enabled": "ВКЛЮЧЕНЫ",
    "disabled": "отключены",
    "healthChecked": "статус проверен",
    "healthNote": "Статус = контрольная плоскость Runpod (только чтение, воркеры не запускаются). Канонический /health на уровне воркера требует запуска оплачиваемого воркера и остаётся за флагом живых вызовов. API подов доступны только локально; все поды остановлены.",
    "refresh": "Обновить статус",
    "colModel": "Модель",
    "colPipeline": "Конвейер",
    "colHealth": "Статус",
    "colDeployment": "Развёртывание",
    "colOperations": "Операции",
    "colAdapter": "Адаптер",
    "pipelineCore": "Основная",
    "pipelineDisabled": "Отключена",
    "pipelineChallenger": "Претендент",
    "pipelineExcluded": "Исключена",
    "pipelineNotIntegrated": "Не интегрирована",
    "podOnly": "Только под",
    "podQualifiedStopped": "Под квалифицирован · остановлен",
    "notDeployed": "не развёрнута",
    "keyNotConfigured": "ключ не настроен",
    "unreachable": "недоступен",
    "running": "работает: {{count}}",
    "ready": "готово: {{count}}",
    "scaledToZero": "свёрнуто до нуля",
    "throttled": "ограничено",
    "unhealthy": "неисправно: {{count}}",
    "queue": "оч.:{{count}}",
    "sortTitle": "Сортировать по развёртыванию (serverless → только под → не развёрнута)",
    "routed": "используется",
    "fleetResident": "H200 · в памяти",
    "fleetDisabled": "H200 · отключена",
    "fleetOnDemand": "H200 · по запросу",
    "observed": {
      "ready": "готова",
      "busy": "занята",
      "loading": "загружается",
      "unloaded": "выгружена",
      "failed": "сбой",
      "unknown": "неизвестно"
    }
  },
  "report": {
    "title": "MedAI — отчёт исследовательского анализа",
    "request": "Запрос",
    "patient": "Пациент",
    "author": "Автор",
    "date": "Создан",
    "source": "Источник",
    "view": "Проекция",
    "image": "Деидентифицированное изображение",
    "summaryTitle": "Сводка доказательств",
    "generatedAt": "Отчёт напечатан",
    "revisions": "Ревизии моделей",
    "none": "—",
    "absent": "Без сигнала моделей: {{findings}}.",
    "missing": "Тире означает отсутствие данных в ячейке, а не отсутствие признака. Баллы не являются процентами или калиброванными вероятностями."
  },
  "review": {
    "title": "4 · Отзыв рецензента",
    "subtitle": "Оцените результаты моделей и резюме. Ваше имя будет записано как рецензент.",
    "waiting": "Рецензирование откроется, когда результаты анализа будут готовы.",
    "findingsTitle": "Оценка признаков",
    "colModels": "Результаты моделей",
    "colAssessment": "Оценка",
    "colComment": "Комментарий (почему неверно, дополнения…)",
    "correct": "Верно",
    "incorrect": "Неверно",
    "summaryTitle": "Оценка резюме",
    "overallTitle": "Общие замечания / дополнения",
    "overallPlaceholder": "Что модели упустили, качество, дальнейшие шаги…",
    "commentPlaceholder": "Необязательный комментарий",
    "submit": "Сохранить рецензию",
    "submitting": "Сохранение…",
    "reviewsTitle": "Рецензии",
    "you": "вы",
    "noAssessments": "Оценок по признакам нет",
    "summaryLabel": "Резюме",
    "agree": "Согласен",
    "disagree": "Не согласен",
    "colAgreement": "Согласие с вердиктом",
    "recordedContext": "Оцените записанные результаты MedSigLIP и MedGemma. Синтетические колонки сравнения не влияют на заключение."
  },
  "draft": {
    "withheld": "Заключение не сформировано: для этого запроса нет принятой доказательной базы. Загрузка модели не отменяет проверку доказательств и критерии допуска.",
    "title": "Мнение MedGemma 27B",
    "demo": "демо — критерии выпуска не пройдены",
    "claims": "Утверждений: {{count}}, каждое связано с принятыми фактами",
    "note": "Текстовый генератор: он не видит изображение — только принятые структурированные факты. Черновик без проверки.",
    "generating": "MedGemma 27B формирует текст…"
  },
  "evidence": {
    "title": "Как читать результат",
    "simulated": "Имитация для демонстрации — это не оценка качества моделей.",
    "research": "Исследовательские данные — не клиническое заключение.",
    "source": "Открытый пример {{sample}} · {{source}}. Эталонные метки — аннотации набора данных, а не новое клиническое заключение.",
    "publicDataset": "открытый исследовательский набор",
    "coverage": "Завершено запусков: {{completed}} / {{total}}.",
    "withheld": "Общий вывод не сформирован. Отдельные ответы не являются принятыми находками.",
    "interpretation": "Значения MedSigLIP — некалиброванные баллы ранжирования, а не вероятности заболевания. Статусы MedGemma — наблюдения модели. Отсутствие данных не означает отсутствие признака.",
    "next": "Проверка специалистом: изучите снимок, проверьте возможные находки и расхождения, внесите исправления во вкладке «Валидация врача». Демонстрация не рекомендует лечение.",
    "mockRun": "имитация",
    "reasons": {
      "thresholds_not_validated": "Пороги не валидированы для целевой популяции; принятые находки не формируются."
    },
    "runStatus": {
      "completed": "завершено",
      "failed": "ошибка",
      "timed_out": "тайм-аут",
      "abstained": "воздержание",
      "queued": "в очереди",
      "running": "выполняется"
    }
  },
  "demoGallery": {
    "eyebrow": "Исследовательская демонстрация · открытые снимки",
    "title": "От снимка к проверяемым данным",
    "intro": "Выберите открытый фронтальный снимок взрослого, запустите модели и изучите каждый ответ с его происхождением. Исходный файл с рабочего стола можно загрузить во вкладке «Загрузить демо-снимок».",
    "images": "{{count}} примеров · взрослые · PA/AP",
    "originals": "Исходные пиксели · эталоны отдельно",
    "research": "Ответы моделей требуют проверки специалистом",
    "imageAlt": "Открытый фронтальный снимок грудной клетки, пример {{number}}",
    "case": "Пример {{number}}",
    "reference": "Эталонный контекст",
    "referenceLimit": "Аннотация источника, а не ожидаемый ответ модели. Отсутствующая метка не означает отсутствие признака.",
    "runs": "Последний случай: завершено {{completed}} / {{total}} реальных запусков",
    "notRun": "Готов к первому запуску",
    "analyze": "Запустить анализ",
    "previous": "Открыть последний результат",
    "measuredTitle": "Измеренное инженерное улучшение",
    "before": "Только инструкция",
    "after": "Вывод по схеме",
    "measuredLimit": "На одном открытом снимке модель выдала 1 из 9 обязательных наблюдений до ограничения по схеме и 9 из 9 после. Это полнота структуры, не точность диагностики и не дообучение весов. Приложение использует словарь из 16 признаков.",
    "tuningTitle": "Что предстоит доказать после настройки",
    "tuningPlan": "Зафиксировать базовую модель и протокол оценки. Настраивать на данных разработки, затем измерять пропуски, ложные сигналы и воздержания на отдельных пациентах и учреждениях с доверительными интервалами. Клиническое качество после настройки пока не измерено.",
    "independence": "Исследования пересекаются с предыдущими подборками и не являются независимым бенчмарком.",
    "allSamples": "Все разрешённые открытые примеры",
    "context": {
      "noFinding": "Эталонная метка: без находок",
      "cardiac": "Эталон: сердечная тень",
      "opacity": "Эталон: затемнение и отёк",
      "multiple": "Несколько эталонных находок",
      "pleuralAir": "Эталонная метка: пневмоторакс",
      "devices": "Сложный снимок с устройствами",
      "tbReference": "ТБ-совместимые проявления, не лабораторное подтверждение",
      "normalReference": "Эталонная метка источника: норма",
      "pneumoniaReference": "Пневмония по исходной разметке",
      "pleuralReference": "Плевральные изменения",
      "edemaReference": "Отёк и консолидация",
      "tbCavityPleural": "ТБ-совместимый референс · полость / утолщение плевры в исходных чтениях",
      "tbInfiltrateCalcification": "ТБ-совместимый референс · инфильтрат / кальцификация в исходных чтениях",
      "tbConsolidationApical": "ТБ-совместимый референс · консолидация / апикальные изменения в исходных чтениях",
      "tbCalcifiedNodes": "ТБ-совместимый референс · кальцинированные узелок и лимфоузел в исходных чтениях",
      "tbEffusionInfiltrate": "ТБ-совместимый референс · плевральный выпот и инфильтрат в исходных чтениях"
    },
    "study": "Исследование {{number}}",
    "studyCount": "Исследований: {{count}}"
  },
  "presets": {
    "eyebrow": "Мгновенная исследовательская демонстрация · Без GPU",
    "title": "Восемь готовых примеров",
    "intro": "Разные публичные рентгенограммы с сохранёнными ответами моделей. Откройте пример сразу или загрузите соответствующий снимок из папки на рабочем столе. Это записанные исследовательские результаты, а не новый анализ.",
    "savedRuns": "Сохранено ответов моделей: {{count}}",
    "open": "Открыть исследование",
    "uploadHint": "Выберите оригинальный снимок: Рабочий стол → MedAI Demo Kit → 01_upload. Точное совпадение содержимого файла открывает сохранённый отчёт после короткой загрузки. GPU и сетевой запуск моделей не используются; другие файлы отклоняются.",
    "banner": "Автономные примеры: сохранённые исследовательские результаты для публичных снимков. Открытие отчёта не запускает модели. Требуется проверка специалистом.",
    "recorded": "Сохранённый пример · Без нового запуска моделей. Время относится к исходному запуску. Исходные запросы и ответы сохранены; отсутствующие признаки не оценивались."
  },
  "golden": {
    "normal": "Нормальный референс",
    "matched": "Признак в ответе модели совпал с разметкой",
    "normalNote": "Нормальный референс; модель указала отсутствие находок",
    "open": "Открыть готовый отчёт",
    "limit": "Подборка показывает отдельные совпадения признаков, а не точность по заболеваниям. Полные ответы, противоречия и причины воздержания доступны в отчёте.",
    "library": "Все 8 примеров · Сравнение девяти моделей · Дополнительные референсы",
    "reportTitle": "Признаки модели, совпавшие с разметкой",
    "reportNote": "Эти признаки указаны в сохранённом ответе MedGemma и в разметке публичного набора. Это сравнение отдельных признаков, а не подтверждённый диагноз.",
    "contradiction": "Исходный ответ модели одновременно содержит положительные признаки и «нет находок». Противоречие сохранено и требует проверки."
  },
  "findings": {
    "atelectasis": "Ателектаз",
    "cardiomegaly": "Кардиомегалия",
    "consolidation": "Консолидация",
    "edema": "Отёк лёгких",
    "enlarged_cardiomediastinum": "Расширение кардиомедиастинальной тени",
    "fracture": "Перелом",
    "hernia": "Грыжа",
    "lung_lesion": "Очаговое образование лёгкого",
    "lung_opacity": "Затемнение лёгочного поля",
    "no_finding": "Без патологии",
    "pleural_effusion": "Плевральный выпот",
    "pleural_other": "Другая патология плевры",
    "pneumonia": "Пневмония",
    "pneumothorax": "Пневмоторакс",
    "support_devices": "Медицинские устройства",
    "pulmonary_tb_suspicion": "Подозрение на туберкулёз лёгких"
  },
  "comparison": {
    "datasetComparisonTitle": "Результаты моделей и референс датасета",
    "title": "Результаты моделей и заключение врача",
    "requestScope": "Выбор заявок",
    "predefined": "Сохранённые исследования",
    "allRequests": "Все заявки",
    "predefinedHint": "Откройте исследование, чтобы сравнить результаты моделей с исходными референсными метками.",
    "savedResults": "Сохранённое исследование · результаты моделей",
    "radiologistTitle": "Заключение врача",
    "datasetTitle": "Референс датасета",
    "sourceLabel": "Метки из исходного набора",
    "radiologistNote": "Референсные метки рентгенологов из исходного датасета. Они независимы от результатов моделей и не являются новой рецензией, внесённой в этом приложении.",
    "datasetNote": "Shenzhen содержит метку рентгенологических проявлений, совместимых с ТБ, а не подтверждённый диагноз ТБ или полное заключение врача по каждой находке.",
    "labelNote": "«Нет метки» означает отсутствие референса для этой находки. Баллы моделей служат для ранжирования и не являются вероятностями заболеваний. Эти выбранные примеры не оценивают точность моделей.",
    "notLabeled": "Нет метки",
    "notAssessed": "Не оценено",
    "withheld": "Воздержание",
    "readerAnnotations": "Сопутствующие признаки в исходных чтениях",
    "sourceReader": "Читатель датасета",
    "annotatedFindings": "Отмеченные признаки",
    "readerNumber": "Читатель {{number}}",
    "readerAnnotationNote": "Исходные аннотации каждого читателя показаны раздельно. Это не согласованные метки и не дополнительные подтверждённые диагнозы. Отсутствие признака в списке не означает отрицательную метку.",
    "synthetic": "Синтетика",
    "syntheticValue": "Иллюстративные значения",
    "syntheticNote": "В колонках «Синтетика» показаны сгенерированные примеры, а не ответы моделей.",
    "scrollModels": "Прокрутите таблицу вправо для сравнения всех моделей.",
    "featured": "Проанализированные",
    "featuredHint": "Три выбранных исследования. Полная библиотека — во вкладке «Сохранённые исследования».",
    "highlightLegend": "Выделены отмеченные признаки и три наибольших балла в каждой колонке.",
    "topRanked": "Один из трёх наибольших баллов в колонке; не клинический порог."
  },
  "playback": {
    "launch": "Запустить анализ",
    "replay": "Повторить просмотр",
    "loading": "Загрузка результатов…",
    "recorded": "Сохранённый анализ",
    "title": "Загружаем результаты исследования",
    "note": "Воспроизведение сохранённых результатов. Модели повторно не запускаются.",
    "stages": {
      "prepare": "Подготовка исследования",
      "table": "Загрузка результатов моделей и таблицы сравнения",
      "report": "Загрузка заключения и исходных референсов"
    }
  },
  "overview": {
    "title": "Рентгенограмма и заключение MedGemma",
    "chestXray": "Рентгенограмма грудной клетки",
    "saved": "Сохранённые результаты",
    "verdict": "Заключение MedGemma",
    "pending": "Ожидается ответ модели.",
    "unavailable": "Завершённое чтение MedGemma недоступно.",
    "withheld": "Общий вывод не сформирован. Наблюдения модели требуют проверки врачом.",
    "review": "Исследовательский ответ модели. Требуется проверка врачом.",
    "notes": "Подробное заключение и примечания"
  }
}
